import { createSlice } from "@reduxjs/toolkit";

const humanResource = createSlice({
    name: "HR",
    initialState:{
        EmployeeList:[
          {
                
            name: "Alex Brown",
            email: "alexbrown@example.com",
            password:'3456',
            contact: "+233" + Math.floor(Math.random() * 1000000000).toString().padStart(9, '0'),
            status: "active",
            dateOfJ: "03-05-2023",
            department: "Teaching",
            
          },
             /* {
                
                name: "Alex Brown",
                email: "alexbrown@example.com",
                password:'3456',
                contact: "+233" + Math.floor(Math.random() * 1000000000).toString().padStart(9, '0'),
                status: "active",
                dateOfJ: "03-05-2023",
                department: "Teaching"
              },
              {
                
                name: "Lisa Green",
                email: "lisagreen@example.com",
                password:'6789',
                contact: "+233" + Math.floor(Math.random() * 1000000000).toString().padStart(9, '0'),
                status: "active",
                dateOfJ: "03-05-2023",
                department: "Labourer"
              },
              {
                
                name: "Mark Lee",
                email: "marklee@example.com",
                password:'2478',
                contact: "+233" + Math.floor(Math.random() * 1000000000).toString().padStart(9, '0'),
                status: "leave",
                dateOfJ: "03-06-2023",
                department: "Tech"
              }
                      {
                
                name: "John Doe",
                email: "johndoe@example.com",
                password:'1234',
                contact: "+233" + Math.floor(Math.random() * 1000000000).toString().padStart(9, '0'),
                status: "active",
                dateOfJ: "03-05-23",
                department: "Tech"
              },
              {
                id: 2,
                name: "Jane Smith",
                email: "janesmith@example.com",
                password:'2345',
                contact: "+233" + Math.floor(Math.random() * 1000000000).toString().padStart(9, '0'),
                status: "leave",
                dateOfJ: "23-05-20",
                department: "Finance"
              },
              */
        ],

      Departments:[


      ]
      ,currentUser:""


    },
    reducers:{
        AddEmployee(state, action){
const newEmployee = action.payload;
state.EmployeeList.push(newEmployee)
        }
        ,

        deleteEmployee(state,action){
          const index = action.payload
        /*const current =  state.Departments.find((item)=>{
        return item.id === action.payload;
           
          })*/
          state.EmployeeList.splice(index,1)

        },
        SetDepartment(state,action){
          state.Departments = action.payload
        },
          
        deleteDepartment(state,action){
          const index = action.payload
        /*const current =  state.Departments.find((item)=>{
        return item.id === action.payload;
           
          })*/
          state.Departments.splice(index,1)

        },
        setCurrentUSer(state,action){
          state.currentUser = action.payload;
        }
    }
})

export const HRactions = humanResource.actions;
export default humanResource;